import './App.css';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Home from './pages/home';
import HomeMobile from './pages/home_mobile';
import View360 from './pages/view360';
import BookingEkho from './pages/booking-ekho';
import BookingCinnamonLodge from './pages/booking-cinnamon-lodge';
import './assets/fonts/fonts.css'

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isMobile = window.innerWidth < 800;
    const isOnMobilePage = location.pathname === '/m';
  
    if (isMobile && location.pathname === '/') {
      navigate('/m');
    } else if (!isMobile && isOnMobilePage) {
      navigate('/');
    }
  }, [navigate, location]);
  

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/m" element={<HomeMobile />} />
      <Route path="/view360" element={<View360 />} />
      <Route path="/bookings/ekho" element={<BookingEkho />} />
      <Route path="/bookings/cinnamon-lodge" element={<BookingCinnamonLodge />} />
     
    </Routes>
  );
}

export default App;
